import React from "react";
import { Line } from "react-chartjs-2";
import EnsaConstant from "../../../pages/Reports/ensa/EnsaConstant";

const ChartLineStatusSosialLiterasi = ({dataProgres, listTitle}) => {
    let listProgres = dataProgres
    const options = {
        responsive: true,
        plugins: {
            legend: {
                display: false,
            },
        },
    };
    let titleUpper = listTitle
    let titleMiddle = listTitle
    let titleLower = listTitle
    let titles = [...titleUpper, ...titleMiddle, ...titleLower]
    let dataUpper = []
    let dataMiddle = []
    let dataLower = []
    for (let i in listProgres.upper) {
        const item = listProgres.upper[i]
        dataUpper.push(item.value)
    }
    for (let i in listProgres.middle) {
        const item = listProgres.middle[i]
        dataMiddle.push(item.value)
    }
    for (let i in listProgres.lower) {
        const item = listProgres.lower[i]
        dataLower.push(item.value)
    }
    let listData = [...dataUpper, ...dataMiddle, ...dataLower]
    const data = {
        labels: titles,
        datasets: [
            {
                label: "",
                data: listData,
                pointStyle: "circle",
                pointRadius: 5,
                pointHoverRadius: 10,
                fill: false,
                showLine: false,
                borderWidth: 1,
                backgroundColor: EnsaConstant.COLOR.CHART_LINE_LITERASI,
                borderColor: EnsaConstant.COLOR.CHART_LINE_LITERASI,
            },
        ],
    };

    return (
        <div style={{ width: '100%' }}>
            <div style={{ width: '100%', display: 'flex', gap: '20px', paddingLeft: '9%', paddingRight: '2%' }}>
                <div style={{ width: '33%', textAlign: 'center' }}>Upper</div>
                <div style={{ width: '33%', textAlign: 'center' }}>Middle</div>
                <div style={{ width: '33%', textAlign: 'center' }}>Lower</div>
            </div>
            <Line data={data} options={options} height={200} />
        </div>
    );
};

export default ChartLineStatusSosialLiterasi;
